import React from 'react'
import './footer.css'
import { AiFillInstagram } from 'react-icons/ai'
import { AiFillLinkedin } from 'react-icons/ai'
import { BsGithub, BsTwitter } from 'react-icons/bs'

const Footer = () => {
  return (
    <footer>
      <a href="#" className='footer__logo'>Ousmane Sangary</a>
      <ul className='permalinks'>
        <li><a href="#">Home</a></li>
        <li><a href="#about">About</a></li>
        <li><a href="#experience">Experience</a></li>
        <li><a href="#services">Services</a></li>
        <li><a href="#project">Project</a></li>
        <li><a href="#testimonial">Testimonials</a></li>
        <li><a href="#contact">Contact</a></li>
      </ul>

      <div className="footer__socials">
        <a href="https://twitter.com/OusmaneSangary2/" target='_blank'><BsTwitter /></a>
        <a href="https://github.com/sangaryousmane" target='_blank'><BsGithub /></a>
        <a href="https://www.linkedin.com/in/ousmane-sangary-3a54011a6/" target='_blank'><AiFillLinkedin /></a>
      </div>

      <div className="footer__copyright">
        <small>&copy; ousmanesangary. All rights reserved </small>
      </div>
    </footer>
  )
}

export default Footer;